import React from "react";
import { creationLine } from "../../utils/creationInfo";

/**
 * Firma detay başlığının TEK SATIRLIK içeriği — depo ve bayi panelleri ortak
 * kullanır (rol grubuna özel bir şey içermez; farklı olan aksiyonlar `actions`
 * slotundan gelir).
 *
 * Düzen cihaz detay başlığıyla aynı: solda kimlik (logo · firma adı · bayser ·
 * üst firma) yer daralınca kısalır, sağda durum rozetleri sarmadan durur; dar
 * ekranda satırın tamamı yatay kayar.
 */
export default function FirmDetailHeaderContent({
  firm,
  firmIcon,
  firmTypeBadge,
  isFetching = false,
  actions = null,
}) {
  if (!firm) return null;

  // Aksiyonlar (üç nokta menüsü) KAYDIRILABİLEN kutunun DIŞINDA (#199):
  // overflow-x-auto dikey taşmayı da keser; butonun altına açılan menü
  // kırpılıp hiç görünmüyordu.
  return (
    <div className="flex-1 min-w-0 flex items-center gap-2 sm:gap-3">
    <div className="flex-1 min-w-0 flex items-center gap-2 sm:gap-3 overflow-x-auto no-scrollbar">
      <div className="hidden sm:flex items-center justify-center w-9 h-9 bg-white rounded-lg border border-gray-200 shadow-sm shrink-0">
        {firmIcon}
      </div>

      {/* Kimlik: firma adı • bayser • üst firma; altında oluşturulma (#343) */}
      <div className="flex flex-col min-w-0">
      <div className="flex items-center gap-1.5 sm:gap-2 min-w-0">
        <h1 className="text-sm sm:text-base font-Bold text-gray-800 truncate">
          {firm.firmName}
        </h1>
        <span className="text-gray-300 shrink-0" aria-hidden="true">
          •
        </span>
        <span className="text-xs sm:text-sm text-gray-500 whitespace-nowrap">
          Bayser: {firm.bayserNo || "-"}
        </span>
        {firm.mainFirmName && (
          <>
            <span className="text-gray-300 shrink-0" aria-hidden="true">
              •
            </span>
            <span className="text-xs sm:text-sm text-gray-500 truncate">
              {firm.mainFirmName}
            </span>
          </>
        )}
      </div>
      <span className="text-[11px] leading-tight text-gray-400 truncate">
        {creationLine(firm)}
      </span>
      </div>

      <span
        className="hidden md:block h-5 w-px bg-gray-300/80 shrink-0"
        aria-hidden="true"
      />

      {/* Durum rozetleri — satırın sağında, sarmaz */}
      <div className="flex items-center gap-1.5 sm:gap-2 shrink-0 ml-auto pl-2">
        <span
          className={`inline-flex items-center gap-1.5 text-xs sm:text-sm font-SemiBold rounded-full px-2 sm:px-2.5 py-0.5 border whitespace-nowrap ${firmTypeBadge.color}`}
        >
          {firmTypeBadge.label}
        </span>
        <span
          className={`inline-flex items-center gap-1.5 text-xs sm:text-sm font-SemiBold rounded-full px-2 sm:px-2.5 py-0.5 whitespace-nowrap ${
            firm.isActive
              ? "text-emerald-700 bg-emerald-50"
              : "text-red-600 bg-red-50"
          }`}
        >
          <span
            className={`inline-flex rounded-full h-2 w-2 shrink-0 ${
              firm.isActive ? "bg-emerald-500" : "bg-red-500"
            }`}
          />
          {firm.isActive ? "Aktif" : "Pasif"}
        </span>
        {isFetching && (
          <div className="w-4 h-4 shrink-0 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
        )}
      </div>
    </div>
    {actions && <div className="shrink-0">{actions}</div>}
    </div>
  );
}
